module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020/0151.jpg?v=b7c0d37a";